export var loadScript = function (url, token) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    if (token) {
      script['data-ad-client'] = token;
    }
    if (script.readyState) {
      // IE
      script.onreadystatechange = function () {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null;
          resolve();
        }
      };
    } else {
      // Others
      script.onload = resolve;
      script.onerror = reject;
    }
    script.src = url;
    document.head.appendChild(script);
  });
};
export var injectScript = function (innerHTML) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    if (script.readyState) {
      // IE
      script.onreadystatechange = function () {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null;
          resolve();
        }
      };
    } else {
      // Others
      script.onload = resolve;
      script.onerror = reject;
    }
    script.innerHTML = innerHTML;
    document.head.appendChild(script);
  });
};